/**
 * Created by JIocb on 26.06.2017.
 */

module Factive.Core {
    import Signal = Factive.Core.Signal.Signal;
    import ISoundManager = Factive.Core.ISoundManager;

    export class Howler1SoundManager implements ISoundManager {
        private _dc: Factive.Core.DependenciesContainer;
        private _list: any;
        private _pending: number = 0;
        private _howl: any;
        private _config: any;
        private _queuePackIds: Array<string> = [];
        private _packIdInLoading: string;
        public signal: Signal;
        private _mute: boolean;
        private _windowMute: boolean;
        private _cdnUrl: string

        constructor(howl: any, configJson: any, cdnUrl: string) {
            this._cdnUrl = cdnUrl;
            this._howl = howl;
            this._config = configJson;
            this.signal = new Signal();
            this._list = {};
            this._mute = false;
            var that = this;
            let hidden = "hidden";


            // Standards:
            if (typeof (document as any).mozHidden != "undefined")
            {
                hidden = "mozHidden";
                document.addEventListener("mozvisibilitychange", onchange);
            }
            else if (typeof (document as any).webkitHidden != "undefined")
            {
                hidden = "webkitHidden";
                document.addEventListener("webkitvisibilitychange", onchange);
            }
            else if (typeof (document as any).msHidden != "undefined")
            {
                hidden = "msHidden";
                document.addEventListener("msvisibilitychange", onchange);
            }
            else if (typeof document.hidden != "undefined")
            {
                document.addEventListener("visibilitychange", onchange);
            }

            // IE 9 and lower:
            else if ("onfocusin" in document)
                (document as any).onfocusin = (document as any).onfocusout = onchange;
            // All others:
            //else
            window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;

            function onchange(evt) {
                var v = "visible",
                    h = "hidden",
                    evtMap = {
                        focus: v,
                        focusin: v,
                        pageshow: v,
                        blur: h,
                        focusout: h,
                        pagehide: h
                    };

                evt = evt || window.event;
                if (evt.type in evtMap) {
                    if(evtMap[evt.type] == "hidden"){
                        that.mute2(true);
                    }else{
                        that.mute2(that._mute);
                    }
                } else {
                    if(document[hidden]){
                        that.mute2(true);
                    }else{
                        that.mute2(that._mute);
                    }
                }
            }

            // set the initial state (but only if browser supports the Page Visibility API)
            if (document[hidden] !== undefined)
                onchange({
                    type: document[hidden] ? "blur" : "focus"
                });
        }

        public load(packId:string): void
        {
            if(this._pending>0)
            {
                this._queuePackIds[this._queuePackIds.length] = packId;

                return;
            }

            this._packIdInLoading = packId;

            var pack:any = this._config[packId];
            var list:Array<any> = pack;
            var l:number = list.length;

            for(var i:number = 0; i<l; i++)
            {
                var snd:any = list[i];

                this.loadAudio(snd);
            }

        };

        private loadAudio( config:any):void
        {
            var key:string =config.name;
            var path:string = this._cdnUrl + config.file;
            var subScripts:Array<string> = config.format;

            var urls = [path];


            this._pending++;
            var that = this;

            var loop:boolean = (config.type=="music");


            var snd;
            if(loop) {

                snd = new this._howl({
                    loop: true,
                    urls: urls,
                    onload: function () {
                        snd.volume(0);
                        snd.stop().play();

                        that.checkIfPackLoaded();
                    },
                    onend: function () {
                        // if ( this._mute )
                        //     return;

                        // snd.stop().play();
                        // if(this._mute)
                        // {
                        //     snd.volume(0);
                        // }
                    }
                });
            }
            else
            {
                snd = new this._howl({
                    urls: urls,
                    onload: function () {
                        that.checkIfPackLoaded()
                    }
                });
            }
            this._list[ key ] = snd;


            // snd.stop().play();console.log('test');
        };

        private checkIfPackLoaded():void
        {
            this._pending--;
            if(this._pending==0)
            {
                this.signal.dispatch("pack_loaded",{id:this._packIdInLoading});

                if(this._queuePackIds.length>0)
                {
                    this._packIdInLoading = null;
                    this.load(this._queuePackIds.shift());
                }
            }
        }

        public playSound(sndName: string, loop: boolean = false, volume: number = 1): void {
            this.play(sndName, loop, volume);
        };

        public play(sndName: string, loop: boolean = false,  volume: number = 1): void {
            let snd = this._list [sndName];
            if(snd)
            {
                snd.volume(volume);

                let cfg = this.getSndConfig(sndName);
                if(cfg.type == "music")
                {
                    if (this._mute)
                    {
                        snd.volume(0);
                    }
                    snd.stop().play();
                }
                else
                {
                    if ( this._mute )
                        return;

                    snd.play();
                }
            }
        };

        public stopSound(sndName: string): void {
            this.stop(sndName);
        };

        private stop(sndName: string): void {
            let snd = this._list[sndName];
            if(snd)
            {
                snd.stop();
            }
        };

        public mute2(value: boolean): void {
            var keys:Array<any> = Object.keys(this._list);
            for(var i:number = 0; i < keys.length; i++)
            {
                var snd = this._list[keys[i]];
                snd.volume(value?0:1);

            }
        };


        public mute(value: boolean): void {
            this._mute = value;
            var keys:Array<any> = Object.keys(this._list);
            for(var i:number = 0; i < keys.length; i++)
            {
                let key:string = keys[i];
                var snd = this._list[key];
                snd.volume(value?0:1);

            }
        };

        private getSndConfig(name:string):any {
            var packKeys = Object.keys(this._config);
            var numPacks: number = packKeys.length;

            for (var i: number = 0; i < numPacks; i++) {

                var pack = this._config[packKeys[i]];
                var l: number = pack.length;

                for (var j: number = 0; j < l; j++) {
                    if (pack[j].name == name) {
                        return pack[j];
                    }
                }
            }
        }
        public destroy(): void
        {
            this.signal.removeAll();
            this.signal = null;

            var keys:Array<any> = Object.keys(this._list);
            for(var i:number = 0; i < keys.length; i++)
            {
                var snd = this._list[keys[i]];
                snd.unload();
            }
            this._list = null;
            this._queuePackIds = null;
            this._pending = 0;
        }

    }
}


// WEBPACK FOOTER //
// src/typescript/Core/Sound/Howler1SoundManager.ts